import React, { useEffect, useState } from "react";
import maskGroupBg from "assets/images/others/attendee-side-images/Maskgroup.png";
import { ReactComponent as EditIcon } from "assets/images/svgs/attendee/edit-attende.svg";
import { ReactComponent as ArrowDown } from "assets/images/svgs/attendee/arrow-down-attende.svg";

import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import { siteRoutes } from "utils/helpers/enums/routes";
import Wishlist from "./component/Wishlist";
import DigitalPassport from "./component/DigitalPassport";
import { useLocation, useNavigate } from "react-router-dom";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import useUtils from "hooks/useUtils";
import useAttendee from "../useHooks";
import PasswordPopup from "./component/PasswordPopup";
import SignedUpExperiences from "./component/SignedUpExperiences";
import Assessment from "./component/Assessment";
import RoadMap from "./component/RoadMap";
import useStore from "hooks/useStore";

interface Tab {
  name: string;
  component: JSX.Element;
}

const FamilyDetail = () => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Minors", path: siteRoutes.familyDetail },
  ];
  const [minor, setMinor] = useState<MinorDTO>(new MinorDTO());
  const tabs: Tab[] = [
    {
      name: "Signed up Experiences",
      component: <SignedUpExperiences minor={minor} />,
    },
    { name: "Wishlist", component: <Wishlist /> },
    { name: "Digital Passport", component: <DigitalPassport /> },
    { name: "Assessment", component: <Assessment /> },
    { name: "Road Map", component: <RoadMap /> },

    // { name: "Favourite Hosts", component: <FavouriteHosts /> },
  ];
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const navigate = useNavigate();
  const { getMinorById } = useAttendee();
  const { getQueryParams, formatDateOfBirth } = useUtils();
  const params = getQueryParams();
  const { isProfileCompleted } = useStore();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  const goToEditMinor = () => {
    navigate(`${siteRoutes.familyInformation}`, { state: { minor } });
  };

  useEffect(() => {
    if (params?.id) {
      getMinorById(params?.id, setMinor);
    }
  }, []);

  const handleChangeTab = (tab: Tab) => {
    setActiveTab(tab);
    navigate(`${window.location.pathname}?id=${params?.id}&tab=${tab.name}`);
  };

  useEffect(() => {
    if (params?.tab) {
      const queryTabName = decodeURIComponent(params?.tab);
      const tab = tabs.find((t) => t.name === queryTabName);
      if (tab) {
        setActiveTab(tab);
      }
    }
  }, []);

  const closeModals = () => {
    setIsPasswordModalOpen(false);
  };

  localStorage.setItem("minorProfile", JSON.stringify(minor));

  return (
    <div>
      <div
        style={{ backgroundImage: `url(${maskGroupBg})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[200px] w-full"
      >
        <div className=" h-full ">
          <div className="container">
            <AttendeeBreadcrumb links={breadcrumbLinks} />
          </div>
        </div>
      </div>
      <div className="container md:mt-[-95px]">
        <div className="flex justify-between flex-wrap items-end  gap-4">
          <div className="flex flex-wrap items-end gap-4">
            <img
              className="w-36 h-36 object-cover border-4 border-white rounded-full"
              src={concatPathWithBackendUrl(minor?.profilePicUrl)}
              alt="profilePic"
            />
            <div>
              <span className="text-2xl text-blackie font-semibold mb-8 flex gap-2 items-end">
                {`${minor.firstName} ${minor.lastName}`}{" "}
                <p className="text-base text-primaryBlueText">@{minor.email}</p>
              </span>
            </div>
          </div>
          <div className="flex gap-3">
            <div
              className="flex gap-2 items-center  bg-fade rounded-full h-12 px-4 cursor-pointer"
              onClick={goToEditMinor}
            >
              <span>
                <EditIcon />
              </span>
              <span className="text-primaryBlueText text-lg">Edit</span>
            </div>

            <div
              className="flex gap-2 items-center  bg-fade rounded-full h-12 px-4 cursor-pointer"
              onClick={() => setIsPasswordModalOpen(true)}
            >
              {/* <span>
                <EditIcon />
              </span> */}
              <span className="text-primaryBlueText text-lg">
                Reset Password
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-10 items-center py-5">
          <div className="flex flex-col gap-3">
            <span className="text-base text-lightBlack font-semibold">
              Date of Birth
            </span>
            <span className="text-sm text-labelTextColor">
              {formatDateOfBirth(minor?.dob)}
            </span>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-base text-lightBlack font-semibold">
              Languages
            </span>
            <span className="text-sm text-labelTextColor">
              {minor?.language}
            </span>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-base text-lightBlack font-semibold">
              Skill Level
            </span>
            <span className="text-sm text-labelTextColor">
              {minor?.skillLevel.replaceAll("_", " ") ?? "-"}
            </span>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-base text-lightBlack font-semibold">
              Interests
            </span>
            <span className="text-sm text-labelTextColor">
              {Array.isArray(minor.interest)
                ? minor.interest.join(", ").replaceAll("_", " ")
                : "-"}
            </span>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-4 flex flex-wrap gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`px-4 py-2 rounded-lg font-medium  transition-colors duration-300 ${
                activeTab.name === tab.name
                  ? "bg-tabsBlueBg text-white"
                  : "bg-fade text-labelTextColor"
              }`}
              onClick={() => handleChangeTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">{activeTab.component}</div>
      </div>
      {isPasswordModalOpen && (
        <PasswordPopup isOpen={isPasswordModalOpen} onClose={closeModals} />
      )}
    </div>
  );
};

export default FamilyDetail;
